// Offre réelle du tunnel de commande (volumes, déchets, prix société HT). Source : MonCompte.jsx / server.py
export const PRICES = {
  '3m³': { 'Terre': 245, 'Gravat/terre': 245 },
  '8m³': { 'Mélange (DIB)': 400, 'Végétaux': 300, 'Terre': 300, 'Gravat/terre': 300, 'Bois': 300, 'Cartons': null, 'Mobilier de bureau': null },
  '10m³': { 'Mélange (DIB)': 480, 'Végétaux': 350, 'Terre': 350, 'Gravat/terre': 350, 'Bois': 350, 'Cartons': null, 'Mobilier de bureau': null },
  '15m³': { 'Mélange (DIB)': 675, 'Végétaux': 675, 'Terre': null, 'Gravat/terre': null, 'Bois': 675, 'Cartons': 675, 'Mobilier de bureau': null },
  '20m³': { 'Mélange (DIB)': 860, 'Végétaux': 860, 'Terre': null, 'Gravat/terre': null, 'Bois': 860, 'Cartons': null, 'Mobilier de bureau': null },
  '30m³': { 'Mélange (DIB)': 1185, 'Végétaux': 1185, 'Terre': null, 'Gravat/terre': null, 'Bois': 1185, 'Cartons': 1185, 'Mobilier de bureau': 1185 },
};

export const VOLUMES = Object.keys(PRICES);

export const prixParticulier = (base) => base;

export const BENNES = {
  '3m³': { description: 'Petits travaux : terre et gravats uniquement', dimensions: 'Dimensions à confirmer selon la benne' },
  '8m³': { description: 'Travaux moyens et rénovations complètes', dimensions: 'L 3,5 m × l 1,8 m × h 1,5 m' },
  '10m³': { description: 'Grands chantiers de démolition', dimensions: 'L 4 m × l 2 m × h 1,6 m' },
  '15m³': { description: 'Chantiers de grande envergure', dimensions: 'L 4,5 m × l 2,2 m × h 1,8 m' },
  '20m³': { description: "Projets de rénovation d'envergure", dimensions: 'L 5 m × l 2,3 m × h 2 m' },
  '30m³': { description: 'Projets industriels et grands travaux', dimensions: 'L 6 m × l 2,4 m × h 2,2 m' },
};

export const CHOIX_DECHETS = [
  { value: 'Gravat/terre', slug: 'gravats', label: 'Gravats / Terre', desc: 'Béton, parpaings, tuiles, terre, pierres', note: 'Déchets lourds : proposés uniquement en 3, 8 et 10 m³.' },
  { value: 'Mélange (DIB)', slug: 'dib', label: 'Mélange (DIB)', desc: 'Bois, plâtre, plastiques, cartons, métaux mélangés', note: 'Disponible de 8 à 30 m³.' },
  { value: 'Bois', slug: 'bois', label: 'Bois', desc: 'Palettes, charpentes, menuiseries', note: 'Disponible de 8 à 30 m³.' },
  { value: 'Végétaux', slug: 'vegetaux', label: 'Végétaux', desc: 'Branches, tontes, feuilles', note: 'Disponible de 8 à 30 m³.' },
  { value: 'Cartons', slug: 'cartons', label: 'Cartons', desc: 'Emballages, cartons', note: 'Disponible en 15 et 30 m³.' },
  { value: 'Mobilier de bureau', slug: 'mobilier', label: 'Mobilier de bureau', desc: 'Bureaux, chaises, armoires', note: 'Disponible en 30 m³.' },
  { value: null, slug: 'autre', label: 'Autre / dangereux', desc: 'Amiante, peintures, solvants, pneus…', note: null },
];

export const volumesDisponibles = (type) => VOLUMES.filter((v) => PRICES[v][type]);

// Faits confirmés (FAQ + conditions acceptées dans le tunnel de commande)
export const FORFAIT_INCLUS = [
  'Location 15 jours calendaires',
  'Livraison et retrait de la benne (transport)',
  'Traitement des déchets en centre agréé',
];

export const TARIFS_NOTE = 'Même tarif HT pour professionnels et particuliers. TVA de 20 % ajoutée au total à payer.';

export const SUPPLEMENTS = [
  { label: 'Livraison Express (le jour même)', valeur: '+100 € HT' },
  { label: 'Passage à vide (absence, accès impossible)', valeur: '180 € HT' },
  { label: 'Immobilisation prolongée', valeur: '100 € HT par 15 jours supplémentaires' },
];

export const A_PREVOIR = [
  'Accès dégagé : 3,5 m de largeur, 4 m de hauteur, 10 m de longueur',
  'Chargement limité à la hauteur des ridelles',
  "Protection du sol à l'emplacement de la benne (ex. bastaings)",
  'Présence obligatoire à la livraison et au retrait',
  'Voie publique : autorisation de voirie à votre charge (CERFA 14023), ou optez pour le Chargement Express',
  'Refusés : amiante, solvants, peintures, pneus, enrobés/goudrons sans analyse HAP, déchets alimentaires',
];

// Pré-remplit le tunnel de commande (même clé localStorage que MonCompte.jsx)
export const prefillCommande = (volume, type) => {
  let saved = {};
  try { saved = JSON.parse(localStorage.getItem('ecoripeurs_form') || '{}'); } catch { saved = {}; }
  localStorage.setItem('ecoripeurs_form', JSON.stringify({ ...saved, selectedVolume: volume, selectedType: type, selectedPrestation: 'depot' }));
};

export const lireSelection = () => {
  try {
    const s = JSON.parse(localStorage.getItem('ecoripeurs_form') || '{}');
    return s.selectedVolume && s.selectedType ? { volume: s.selectedVolume, type: s.selectedType } : null;
  } catch { return null; }
};
